<template>
    <CFormGroup
            v-bind="{append, prepend, validFeedback, invalidFeedback,
        tooltipFeedback, description, wrapperClasses, class: computedClasses}"
    >
        <template #label>
            <slot name="label">
                <label v-if="label" :for="safeId" :class="labelClasses">
                    {{label}}
                </label>
            </slot>
        </template>
        <template #input>
            <input
                    v-bind="$attrs"
                    v-on="listeners"
                    :id="safeId"
                    :type="type"
                    :class="inputClasses"
                    :readonly="readonly || plaintext"
                    :value="state"
                    @input="onInput($event)"
                    @change="onChange($event)"
            />
        </template>

        <template
                v-for="slot in $options.slots"
                #[slot]
        >
            <slot :name="slot"></slot>
        </template>
    </CFormGroup>
</template>

<script>
    import CFormGroup from '@coreui/vue/src/components/form/CFormGroup'
    import { inputProps as props } from '@coreui/vue/src/components/form/form-props'
    import * as allFormMixins from '@coreui/vue/src/components/form/form-mixins'
    const mixins = Object.values(allFormMixins)

    export default {
        name: 'CInput',
        slots: [
            'prepend',
            'prepend-content',
            'append-content',
            'append',
            'label-after-input',
            'valid-feedback',
            'invalid-feedback',
            'description'
        ],
        inheritAttrs: false,
        components: { CFormGroup },
        mixins,
        props,

        data () {
            return {
                state: this.value,
                syncTimeout: null
            }
        },
        computed: {
            listeners () {
                const { input, change, ...listeners } = this.$listeners // eslint-disable-line no-unused-vars
                return listeners
            }

        },
        methods: {
            onInput (e) {
                console.log("on input")
                e.target.value = this.commaOnly(e.target.value).replace(/,/g, '');
                this.state = this.get_currency(e.target.value)
                this.$emit('input', this.state, e)
                if (this.lazy === true) {
                    return
                }

                clearTimeout(this.syncTimeout)
                this.syncTimeout = setTimeout(() => {
                    // console.log("on lazy")

                    this.$emit('update:value', this.state, e)
                }, this.lazy !== false ? this.lazy : 0)
            },
            onChange (e) {
                // console.log("on change")

                this.state = this.get_currency(e.target.value)
                // this.$emit('input', this.state.replace(/,/g, ''), e)

                this.$emit('change', this.state, e)
                this.$emit('update:value', this.state, e)
            },commaOnly(input){

                var value = input;
                var values = value.split("");

                var update = "";

                // var expression=/(^\d+$)|(^\d+\.\d+$)|[,\.]/;
                var finalExpression=/^([0-9][0-9]*[,\.]?\d{0,3})$/;
                values.forEach((val) => {

                    // if (expression.test(values[val])==true && values[val]!=''){
                    //     transition+=''+values[val].replace('.',',');
                        if(finalExpression.test(val) == true){
                            update+=''+val;
                        }
                    // }
                });

                return  update;
            }
        },


    }
</script>
